import Brand from '@/classes/brand';
import BrandsData from '@/data/brands.json';

let brands: Array<Brand> = BrandsData.map(brand => {
  return new Brand(brand);
});

export default {
  get(matchStr: string): Brand {
    let found = brands.find((brandMatch: Brand) => {
      let brandMatchRegex = new RegExp(brandMatch.domain, 'gi');
      return matchStr.search(brandMatchRegex) > -1;
    });
    return found || brands[0];
  },
  byId(id: any): Brand {
    let brand: any = brands.find((brand: Brand) => {
      return brand.id == id;
    });
    return brand || this.default();
  },
  default(): Brand {
    return brands[0];
  }
};
